import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, ThemeContext } from './components/ThemeProvider';
import { useContext, useState, useEffect } from 'react';

import Intro from './components/Intro';
import Navbar from './components/Navbar';
import About from './components/About';
import CaseStudies from './components/CaseStudies';
import Projects from './components/Projects';
import CodeSamples from './components/CodeSamples';
import Experience from './components/Experience';
import Testimonials from './components/Testimonials';
import Education from './components/Education';
import Certifications from './components/Certifications';
import Skills from './components/Skills';
import TechDeepDive from './components/TechDeepDive';
import WhyWorkWithMe from './components/WhyWorkWithMe';
import Contact from './components/Contact';
import Footer from './components/Footer';

function AppContent() {
  const { toggleTheme } = useContext(ThemeContext);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [showIntro, setShowIntro] = useState(true);

  // Reset intro on every page load/refresh
  useEffect(() => {
    // Ensure intro always shows on initial load
    setShowIntro(true);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrolled = window.scrollY;
      const progress = windowHeight > 0 ? (scrolled / windowHeight) * 100 : 0;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleIntroComplete = () => {
    setShowIntro(false);
  };

  return (
    <Router>
      <div className="App" style={{ backgroundColor: '#000000' }}>
        {showIntro && <Intro onComplete={handleIntroComplete} />}
        
        {!showIntro && (
          <>
            <div className="scroll-progress" style={{ width: `${scrollProgress}%` }}></div>
            <Navbar toggleTheme={toggleTheme} />
            <Routes>
              {/* Home Route */}
              <Route
                path="/"
                element={
                  <>
                    <About />
                    <Experience />
                    <Testimonials />
                    <Education />
                    <Certifications />
                    <CaseStudies />
                    <Projects />
                    <CodeSamples />
                    <Skills />
                    <TechDeepDive />
                    <WhyWorkWithMe />
                    <Contact />
                    <Footer />
                  </>
                }
              />

              {/* Projects Route */}
              <Route path="/projects" element={<Projects />} />

              {/* Skills Route */}
              <Route path="/skills" element={<Skills />} />
            </Routes>
          </>
        )}
      </div>
    </Router>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
